import { inject, Injectable } from '@angular/core';
import { LocalStorageDataAccess } from '@softline/core';
import { Template } from '../../user/templates/template';
import { TemplateRepository } from './template.repository';

const KEY = 'template';
@Injectable()
export class LocalStorageTemplateRepository extends TemplateRepository{
  private dataAccess = inject(LocalStorageDataAccess)

  constructor() {
    super();
  }

  override async loadGroup<T>(group: string): Promise<Template<T>[]> {
    const result = this.dataAccess.get<Template<T>[]>({key: KEY})
    if(!result)
      return [];
    return result.filter(o => o.group === group);
  }

  override async create<T>(template: Template<T>): Promise<Template<T>> {
    const result = this.dataAccess.get<Template<any>[]>({key: KEY}) ?? [];
    const index = result.findIndex(o => o.id === template.id);
    if(index > -1) {
      result[index] = template;
    } else {
      result.push(template);
    }
    this.dataAccess.set<Template<T>[]>({key: KEY}, result);
    return template;
  }

  override async delete<T>(id: string): Promise<Template<T>> {
    const result = this.dataAccess.get<Template<T>[]>({key: KEY}) ?? [];
    const index = result.findIndex(o => o.id === id);
    if(index > -1) {
      const [template] = result.splice(index, 1);
      this.dataAccess.set<Template<T>[]>({key: KEY}, result);
      return template;
    }
    throw new Error(`Template with id ${id} not found`);
  }
}
